import { render, staticRenderFns } from "./paymentsbyuserreport.vue?vue&type=template&id=96c5135a&scoped=true&"
import script from "./paymentsbyuserreport.vue?vue&type=script&lang=js&"
export * from "./paymentsbyuserreport.vue?vue&type=script&lang=js&"
import style0 from "./paymentsbyuserreport.vue?vue&type=style&index=0&id=96c5135a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c5135a",
  null
  
)

export default component.exports